import React, { Component } from 'react';

import { withRouter } from 'react-router';


import AddToList from '../../applicant/add-to-list/add-to-list.component';
import RecommendedArticles from '../../recommended-articles/recommended-articles.component';
import Jobs from './jobs.component';

// styles & icons
import { Row, Col, Container } from 'react-bootstrap';
import { Paper, Button } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import workIcon from '../../../images/work.svg';

class AppliedAndSavedJobs extends Component {
    constructor(){
        super();
        this.state = []
    }
    render() {
        return (
            <div className="applied-jobs">
                <Container className="pt-4">
                    <Row>
                        <Col md={12}>
                            <Paper className="p-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                                <Row >
                                    <Col md={12}>
                                        <Row className="m-0 mb-3 align-items-center">
                                            <Col className="text-left p-0">
                                                <h6 className="bold mb-0">
                                                    My  posts
                                                </h6>
                                                <p className="pt-2">All your saved and Applied jobs in one place</p>
                                            </Col>
                                        </Row>
                                        <Row className="m-0 mb-3">
                                            <Col className="p-0">
                                                <Button 
                                                    size="small" 
                                                    style={{ fontSize: '0.8rem' }} 
                                                    className="bg-grey btn-black mr-2 pr-2 pl-2 active" 
                                                    varient="contained"
                                                >
                                                    Saved Job posts
                                                </Button>
                                                <Button 
                                                    size="small" 
                                                    style={{ fontSize: '0.8rem' }} 
                                                    className="bg-grey btn-black pr-2 pl-2" 
                                                    varient="contained"
                                                >
                                                    Applied Job posts
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Paper>
                            <Jobs   />
                        </Col>
                        {/* <Col className="p-0" md={4}>
                            <AddToList/>
                            <RecommendedArticles/>
                        </Col> */}
                    </Row>
                </Container>
            </div>
        )
    }
}

export default withRouter(AppliedAndSavedJobs);